export default "__VITE_ASSET__f08f21df__"